import { AIJobRequest } from './ai-job-request';
import { IAIObjectDetectionClass } from './i-ai-object-detection-class';
import { AIObjectDetectionAnalyzeClass } from './ai-object-detection-analyze-class';

export class ScheduleAiJobRequest {
  constructor(
    public Guid: string,
    public AssociatedMediaId: number,
    public RequestBody: AIJobRequest,
  ) {}

  public static createWithDetectionClasses(
    jobUid: string,
    url: string,
    mediaId: number,
    required_classes: IAIObjectDetectionClass[],
  ): ScheduleAiJobRequest {
    const aiDetectionClass = new AIObjectDetectionAnalyzeClass(required_classes);
    const jobRequest = new AIJobRequest(jobUid, url, [aiDetectionClass]);
    return new ScheduleAiJobRequest(jobUid, mediaId, jobRequest);
  }
}
